import React from "react";
import DocumentMeta from "./DocumentMeta";
import { ROUTE_META } from "./routeMeta";

const storeLinks = [
  {
    label: "Google Play",
    href: "https://play.google.com/store/apps/details?id=com.appazzola.pawmergeidle&pcampaignid=web_share",
    img: "https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg",
    alt: "Get it on Google Play",
  },
  {
    label: "App Store",
    href: "https://apps.apple.com/us/app/paw-merge-idle/id6761851044",
    img: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg",
    alt: "Download on the App Store",
  },
];

const legalLinks = [
  {
    label: "Privacy Policy",
    href: "/privacy/paw-merge-idle",
  },
  {
    label: "Terms of Service",
    href: "/terms/paw-merge-idle",
  },
];

const PawMergeIdlePage = () => (
  <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(167,139,250,0.22),_transparent_34%),linear-gradient(135deg,_#fffbeb,_#ffffff_48%,_#f5f3ff)] px-6 py-12 text-gray-900">
    <DocumentMeta
      title={ROUTE_META.pawMergeGame.title}
      description={ROUTE_META.pawMergeGame.description}
      robots={ROUTE_META.pawMergeGame.robots}
    />

    <div className="mx-auto max-w-5xl">
      <a
        href="/"
        className="inline-flex items-center gap-2 rounded-full border border-amber-100 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm transition hover:border-violet-300 hover:text-violet-700"
      >
        <span aria-hidden="true">&larr;</span>
        Back to home
      </a>

      <section className="mt-8 overflow-hidden rounded-3xl border border-white bg-white/90 shadow-[0_30px_120px_rgba(15,23,42,0.12)] ring-1 ring-violet-100/70">
        <div className="grid gap-10 p-8 lg:grid-cols-[1fr_24rem] md:p-12">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-violet-500">
              Mobile Game
            </p>
            <h1 className="mt-4 text-5xl font-extrabold tracking-tight text-gray-900 md:text-6xl">
              Paw Merge Idle
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-gray-600">
              Paw Merge Idle is a cozy cat merge-and-idle game: spawn paws,
              merge your way to gold, unlock rooms for your roster, and watch
              passive catnip roll in while you are away.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              {["Merge board", "Cat rooms", "Cloud save", "Leaderboards"].map(
                (item) => (
                  <span
                    key={item}
                    className="rounded-full border border-violet-200 bg-violet-50 px-4 py-2 text-sm font-semibold text-violet-700"
                  >
                    {item}
                  </span>
                ),
              )}
            </div>

            <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
              {storeLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex h-14 items-center justify-center rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl"
                >
                  <img src={link.img} alt={link.alt} className="h-10" />
                </a>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              {legalLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm font-semibold text-violet-700 underline decoration-violet-300 underline-offset-4 transition hover:text-violet-900"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="rounded-3xl border border-violet-100 bg-gradient-to-br from-amber-50 to-violet-50 p-4 text-center shadow-[0_20px_80px_rgba(109,40,217,0.14)] md:p-5">
            <img
              src="/pmi-feature.jpg"
              alt="Paw Merge Idle feature graphic"
              className="mx-auto aspect-video w-full rounded-[1.5rem] object-cover shadow-xl ring-1 ring-white"
            />
            <p className="mt-6 text-sm font-semibold uppercase tracking-[0.24em] text-violet-700">
              Live
            </p>
            <p className="mt-2 text-sm leading-6 text-gray-600">
              Available on Google Play and the App Store.
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default PawMergeIdlePage;
